//= =================================== React-IMPORT ==================================================================//
import React from 'react';
//= =================================== AEM-IMPORT ====================================================================//
//= =================================== MUI-IMPORT ====================================================================//
//= =================================== Icon ==========================================================================//
import SvgIcon from '@material-ui/core/SvgIcon';
//= =================================== App component =================================================================//
//= =================================== Utility =======================================================================//
//= =================================== Redux action ==================================================================//
//= =================================== Styles ========================================================================//
//= =================================== Class definition ==============================================================//
const ChevronRightIcon = (props) => (
  <SvgIcon
    width="8"
    height="14"
    viewBox="0 0 8 14"
    className={props.className}
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M0.506281 0.881282C0.164573 1.22299 0.164573 1.77701 0.506281 2.11872L5.38756 7L0.506281 11.8813C0.164573 12.223 0.164573 12.777 0.506281 13.1187C0.847991 13.4604 1.40201 13.4604 1.74372 13.1187L7.24372 7.61872C7.58543 7.27701 7.58543 6.72299 7.24372 6.38128L1.74372 0.881282C1.40201 0.539573 0.847991 0.539573 0.506281 0.881282Z" />
  </SvgIcon>
);
//= =================================== Component props ===============================================================//

//= =================================== Redux map props ===============================================================//

//= =================================== Export ========================================================================//
export default ChevronRightIcon;
